<i18n>
{
  "ru":{
    "payment_search": "Поиск по платежам"
  },
  "en":{
    "payment_search": "Payments search"
  }
}
</i18n>
<template>
  <div style="margin: auto;max-width: 900px;">
    <payment-modal v-if="showPaymentModal" :visible.sync="showPaymentModal" />

    <invoice-details-modal
      v-if="showInvoiceDetailsModal"
      :visible.sync="showInvoiceDetailsModal"
      :url="invoiceDetailsUrl"
    />

    <!-- <el-row
      :gutter="20"
      type="flex"
    >
      <el-col class="aligner right">
        <el-button
          round
          type="info"
          plain
          disabled
          @click.prevent="showPayment()"
        >{{$t('excel_export')}}</el-button>
      </el-col>
    </el-row> -->
    <el-row :gutter="20" v-loading="loading">
      <el-col v-if="filter">
        <el-card>
          <h2 class="search--panel-title">{{ $t('payment_search') }}:</h2>
          <el-form
            class="search_filter payments"
            :class="filterCollapsed && emptyFilter ? 'collapsed' : ''"
            @submit.native.prevent="loadPayments"
          >
            <input class="hidden-input" ref="hidden" />
            <el-row :gutter="20">
              <!-- <el-col :sm="8" style="position: relative">
                <div class="el-loading-mask"></div>
                <span class="label"></span>
                <el-input ></el-input>
              </el-col>-->
              <el-col :sm="6">
                <a
                  href="#"
                  class="label"
                  @click.prevent="changeSort('batch_timestamp')"
                >
                  {{ $t('batch_date') }}
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'batch_timestamp' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'batch_timestamp' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
                <el-date-picker
                  type="date"
                  ref="from"
                  size="mini"
                  v-model="filter.search_form_batch_timestamp_date_from"
                  @change="$refs['hidden'].focus()"
                  :placeholder="$t('from')"
                ></el-date-picker>
              </el-col>
              <el-col :sm="6">
                <span class="label">&nbsp;</span>
                <el-date-picker
                  type="date"
                  size="mini"
                  v-model="filter.search_form_batch_timestamp_date_to"
                  @change="$refs['hidden'].focus()"
                  :placeholder="$t('to')"
                ></el-date-picker>
              </el-col>
              <el-col :sm="6">
                <span class="label">RRN</span>
                <el-input
                  size="mini"
                  v-model="filter.search_form_reserv2"
                ></el-input>
              </el-col>
              <el-col :sm="6">
                <span class="label">E-mail</span>
                <el-input
                  size="mini"
                  placeholder="E-mail"
                  v-model="filter.search_form_email"
                ></el-input>
              </el-col>
              <el-col :sm="6">
                <span class="label">{{ $t('invoice_id') }}</span>
                <el-input
                  size="mini"
                  v-model="filter.search_form_invoice_id"
                ></el-input>
              </el-col>
              <el-col :sm="6">
                <a href="#" class="label" @click.prevent="changeSort('id')">
                  {{ $t('transaction_id') }}
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'id' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'id' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
                <el-input
                  size="mini"
                  v-model="filter.search_form_id"
                ></el-input>
              </el-col>
              <el-col :sm="6">
                <a
                  href="#"
                  class="label"
                  @click.prevent="changeSort('masked_pan')"
                >
                  {{ $t('by_card') }}
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'reserv3' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'reserv3' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
                <el-row>
                  <el-col :span="8">
                    <el-input
                      size="mini"
                      v-model="filter.search_form_reserv3[0]"
                      maxlength="6"
                      class="input-no-padding"
                    ></el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      size="mini"
                      disabled
                      placeholder="XX XXXX"
                      class="input-no-padding"
                    ></el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      size="mini"
                      v-model="filter.search_form_reserv3[1]"
                      maxlength="4"
                      class="input-no-padding"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :sm="6">
                <span class="label">{{ $t('status') }}</span>
                <el-select
                  size="mini"
                  v-model="filter.search_form_distinct_status"
                >
                  <el-option label="Authorized" value="4"></el-option>
                  <el-option label="Completed" value="1"></el-option>
                  <el-option label="Declined" value="2"></el-option>
                  <el-option label="Partial Voided" value="9"></el-option>
                  <el-option label="Pending" value="3"></el-option>
                  <el-option label="Recurrent" value="10"></el-option>
                  <el-option label="Refunded" value="5"></el-option>
                  <el-option label="System" value="6"></el-option>
                  <el-option label="Voided" value="7"></el-option>
                  <el-option label="Verification" value="23"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="{ span: 6, offset: 18 }" :xs="24">
                <!-- <span class="label">&thinsp;</span> -->
                <div>
                  <el-button round type="danger" size="mini" @click="reset()">{{
                    $t('clear')
                  }}</el-button>
                  <el-button
                    round
                    type="primary"
                    size="mini"
                    native-type="submit"
                    >{{ $t('search') }}</el-button
                  >
                </div>
              </el-col>
            </el-row>
          </el-form>
          <el-row class="aligner">
            <i
              class="filter-collapse-icon"
              :class="{ open: filterCollapsed && emptyFilter }"
              @click="filterCollapsed = !filterCollapsed"
            ></i>
          </el-row>
        </el-card>
      </el-col>
      <el-col v-if="tableData.length">
        <el-card v-for="payment in tableData" :key="payment.id">
          <div
            class="list-item-header payment"
            @click="payment.show = !payment.show"
          >
            <el-row :gutter="20">
              <el-col :span="5" :xs="12">
                <div class="list-item-text">
                  {{ $t('transaction_id') }}:
                  <span>{{ payment.id }}</span>
                </div>
                <div class="list-item-text">
                  {{ $t('invoice_id') }}:
                  <span>
                    <a
                      href="#"
                      @click.prevent.stop="
                        goToInvoice(payment.transaction_invoice_url)
                      "
                      >{{ payment.invoice_transaction_invoice_id }}</a
                    >
                  </span>
                </div>
              </el-col>
              <el-col :span="5" :xs="12">
                <div class="list-item-text">
                  {{ $t('payment_method') }}:
                  <span>
                    <span
                      class="card_brand"
                      :class="{
                        visa: payment.card == 'VISA',
                        mastercard:
                          payment.card == 'MASTERCARD' || payment.card == 'MC',
                        belcard: payment.card == 'БЕЛКАРТ',
                        belqi: payment.card == 'BELQI WALLET'
                      }"
                    ></span>
                    <span>{{ payment.transaction_log_reserv3 }}</span>
                  </span>
                </div>
              </el-col>
              <el-col :span="5" :xs="8">
                <div class="list-item-text">
                  {{ $t('sum') }}:
                  <span>
                    {{ payment.amt }}
                    <span class="item_payment_amount">{{
                      payment.currency_id
                    }}</span>
                  </span>
                </div>
                <div class="list-item-text">
                  {{ $t('status_3ds') }}:
                  <span>{{
                    $t(payment.transaction_log_tds_using == '1' ? 'yes' : 'no')
                  }}</span>
                </div>
              </el-col>
              <el-col :span="5" :xs="8">
                <div class="list-item-text">
                  {{ $t('payer') }}:
                  <span>{{ payment.account_username }}</span>
                </div>
                <div class="list-item-text">
                  {{ $t('processing_gateway') }}:
                  <span v-if="payment.billing_processing_gateway">{{
                    $t(
                      'processing_gateway_' + payment.billing_processing_gateway
                    )
                  }}</span>
                  <span v-if="!payment.billing_processing_gateway">-</span>
                </div>
              </el-col>
              <el-col :span="4" :xs="8">
                <div class="list-item-text">
                  {{ $t('status') }}:
                  <span>{{ payment.text_status }}</span>
                </div>
                <div class="list-item-text">
                  {{ $t('batch_date') }}:
                  <span>{{ payment.batch_timestamp }}</span>
                </div>
              </el-col>
            </el-row>
          </div>

          <payment-details
            v-if="payment.url_transaction && payment.show"
            :visible.sync="payment.show"
            :url="payment.url_transaction"
          ></payment-details>
        </el-card>
      </el-col>
      <el-col v-if="tableData.length" :offset="0" :span="24">
        <el-card>
          <el-pagination
            class="aligner right"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            layout="total, prev, pager, next"
            :total="pagination.total"
            @current-change="changePage"
          ></el-pagination>
        </el-card>
      </el-col>
      <el-col :span="24" v-if="!loading && !tableData.length">
        <el-card class="aligner">{{ $t('notfound') }}</el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiRes from '../../core/apiRes'
import { eventBus } from '../../event-bus'
import PaymentModal from './PaymentModal'
import PaymentDetails from './PaymentDetails'
import InvoiceDetailsModal from '../invoices/InvoiceDetailsModal'
import InvoiceRefundModal from '../invoices/InvoiceRefundModal'

export default {
  name: 'payments',
  components: {
    'payment-modal': PaymentModal,
    'invoice-refund-modal': InvoiceRefundModal,
    'payment-details': PaymentDetails,
    'invoice-details-modal': InvoiceDetailsModal
  },
  data: () => ({
    filter: null,
    pagination: null,

    pageLinks: {},
    sortLinks: {},

    tableData: [],
    loading: true,

    showPaymentModal: false,
    showInvoiceDetailsModal: false,
    invoiceDetailsUrl: '',
    filterCollapsed: true
  }),
  created () {
    this.reset()
    eventBus.$on('reload', this.reloadRoute)
  },
  beforeDestroy () {
    eventBus.$off('reload', this.reloadRoute)
  },
  methods: {
    reloadRoute (route) {
      if (route === this.$router.currentRoute.name) {
        this.reset()
      }
    },
    goToInvoice (url) {
      if (url) {
        this.invoiceDetailsUrl = url
        this.showInvoiceDetailsModal = true
      }
    },
    reset () {
      this.initData()
      this.loadPayments()
    },
    initData () {
      this.filter = {
        search_form_distinct_id: '',
        search_form_batch_timestamp_date_from: '',
        search_form_batch_timestamp_date_to: '',
        search_form_reserv3: ['', ''],
        search_form_reserv2: '',
        search_field_type_reserv2: 'direct_like',
        search_form_processing: '',
        search_field_type_processing: 'direct_like',
        search_form_email: '',
        search_field_type_email: 'left_like',
        search_form_invoice_id: '',
        search_field_type_invoice_id: 'direct',
        search_form_id: '',
        search_field_type_id: 'direct',
        search_form_account_id: '',
        search_field_type_account_id: 'direct',
        search_form_payment_method_data: '',
        search_form_distinct_status: '',
        search_form_payment_method: '',
        search_field_type_payment_method: 'direct',
        submit: 'Поиск',

        order_type: '',
        order_field: ''
      }

      this.pagination = {
        total: 0,
        pageSize: 25,
        currentPage: 0
      }
    },
    parsePayments (promise) {
      this.loading = true
      this.tableData = []
      promise.then((data) => {
        if (data.page_vars) {
          let vars = data.page_vars
          vars.res.records.forEach(r => {
            if (r.batch_timestamp) {
              console.log(r.batch_timestamp);
              r.batch_timestamp = new Date(parseInt(r.batch_timestamp) * 1000).toLocaleString(this.$localeForDate)
              console.log('gfd'+ r.batch_timestamp);
            }
            if (r.card) {
              r.card = r.card.toUpperCase()
            }

            r.show = false
          })
          this.tableData = vars.res.records
          this.pagination = {
            total: parseInt(vars.res.results),
            currentPage: parseInt(vars.res.cpage),
            pageSize: parseInt(vars.res.limit)
          }

          if (!this.pageLinks) this.pageLinks = {}
          if (vars.paginator) {
            if (vars.paginator.end_pages) {
              Object.keys(vars.paginator.end_pages).forEach(k => {
                this.pageLinks[k] = vars.paginator.end_pages[k]
              })
            }
            if (vars.paginator.pre_pages) {
              Object.keys(vars.paginator.pre_pages).forEach(k => {
                this.pageLinks[k] = vars.paginator.pre_pages[k]
              })
            }
            if (vars.paginator.next_pages) {
              Object.keys(vars.paginator.next_pages).forEach(k => {
                this.pageLinks[k] = vars.paginator.next_pages[k]
              })
            }
          }

          this.filter.order_field = vars.res.order
          this.filter.order_type = vars.res.sort
          this.sortLinks = vars.transaction_data
        } else {
          this.tableData = []
          this.pagination = {}
        }

        this.loading = false
      }).catch(() => {
        this.$notify.error({
          title: this.$t('error'),
          message: ''
        })
        this.loading = false
      })
    },
    loadPayments () {
      this.parsePayments(apiRes.post(apiRes.paymentsUrl, this.filter))
    },
    changePage (newPage) {
      if (this.pageLinks[newPage]) {
        this.parsePayments(apiRes.get(this.pageLinks[newPage]))
      }
    },
    changeSort (name) {
      if (this.filter.order_field === name) {
        this.filter.order_type = this.filter.order_type === 'asc' ? 'desc' : 'asc'
      } else {
        this.filter.order_field = name
        this.filter.order_type = 'asc'
      }

      this.loadPayments()
      // if (this.sortLinks[name]) {
      //   this.parsePayments(apiRes.get(this.sortLinks[name]))
      // }
    }
  },
  computed: {
    emptyFilter () {
      return !this.filter ||
        (!this.filter.search_form_batch_timestamp_date_from &&
          !this.filter.search_form_batch_timestamp_date_to &&
          !this.filter.search_form_reserv2 &&
          !this.filter.search_form_email &&
          !this.filter.search_form_invoice_id &&
          !this.filter.search_form_id &&
          !this.filter.search_form_reserv3[0] &&
          !this.filter.search_form_reserv3[1])
    }
  }
}
</script>

<style>
.list-item-header.payment .card_brand {
  height: 40px;
  width: 80px;
}

.list-item-header.payment .card_brand + span {
  display: inline-block;
  margin-left: 5px;
}

.item_payment_amount {
  color: #c1c1c1;
  font-size: 10px;
}

.payment-refand-ok {
  background-color: rgba(254, 146, 146, 0.08);
}

.payment-refand-ok:hover {
  background-color: rgba(254, 146, 146, 0.3);
}

.search_filter.payments:not(.collapsed) {
  height: 180px;
}

.search_filter.payments.collapsed {
  height: 72px;
}

@media only screen and (max-width: 420px),
  (min-width: 420px) and (max-width: 767px) {
  .search_filter.payments.collapsed {
    height: 250px;
  }
  .search_filter.payments:not(.collapsed) {
    height: 570px;
  }
}
</style>
